import { render, staticRenderFns } from "./BackgroundAnimation.vue?vue&type=template&id=3fc3b788"
import script from "./BackgroundAnimation.vue?vue&type=script&lang=js"
export * from "./BackgroundAnimation.vue?vue&type=script&lang=js"
import style0 from "./BackgroundAnimation.vue?vue&type=style&index=0&id=3fc3b788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports